import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  List,
  ListSubHeader,
  ListCheckbox,
  Button,
  Autocomplete,
  IconButton,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import { MenuItem } from 'react-toolbox/lib/menu'
import { Flex, Box } from 'reflexbox'

import MenuButton from 'components/fulcrum/button/MenuButton'

import styles from './styles.scss'

class ListFilter extends Component {
  constructor(props) {
    super(props)
    this.filters = {}
    this.filterNames = {}
    this.filterVal = []
  }

  onSelectFilter() {
    return (index) => {
      this.props.onSelectFilter(index)
    }
  }

  renderFilterMenu() {
    const filterPairs = this.props.filterPairs
    const filterArr = []

    for (const filterType in filterPairs) {
      if (!filterPairs.hasOwnProperty(filterType)) continue

      const filterValues = _.cloneDeep(filterPairs[filterType])
      const filterName = filterValues.pop()

      filterArr.push(
        <MenuItem key={filterType} value={filterType} caption={filterName} />
      )
      this.filters[filterType] = filterValues.map(filter => filter.label)
      this.filterNames[filterType] = filterName
    }

    return(
      <MenuButton
        icon='add'
        label='Add Filter'
        position='bottomRight'
        menuRipple
        onSelect={this.onSelectFilter()}
        theme={styles}
      >
        {filterArr}
      </MenuButton>
    )
  }

  onAutoCompleteSelect(handler, curfilterStatus, index) {
    return (value) => {
      // skip if current value is already selected in another filter
      if (curfilterStatus[value]) {
        this.filterVal[index] = value
        return
      }

      // turn off previous filter if there exists one
      const prevVal = this.filterVal[index]
      if (prevVal) {
        handler(prevVal)
      }

      this.filterVal[index] = value
      handler(value)
    }
  }

  onDeleteFilter(handler, curfilterStatus, index) {
    return () => {
      const curVal = this.filterVal[index]
      if (curfilterStatus[curVal]) {
        handler(curVal)
      }

      this.filterVal.splice(index, 1)
      this.props.onDeleteFilter(index)
    }
  }

  onRefreshFilter() {
    return () => {
      this.props.onRefreshFilter()
      this.filterVal = this.filterVal.map(value => {
        return ''
      })
    }
  }

  renderFilterItem() {
    const {
      filterHandlers,
      filterStatus,
    } = this.props

    return(
      <div styleName='filterWrapper'>
        {this.props.selectedFilter.map((filter, index) => {
          return(
            <div styleName='filterItemWrapper' key={index}>
              <Autocomplete
                label={`Choose ${this.filterNames[filter]}`}
                onChange={this.onAutoCompleteSelect(filterHandlers[filter], filterStatus[filter], index)}
                source={this.filters[filter]}
                value={this.filterVal[index]}
                multiple={false}
                direction='down'
                theme={styles}
              />
              <IconButton
                icon='delete'
                onClick={this.onDeleteFilter(filterHandlers[filter], filterStatus[filter], index)}
                primary
              />
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const filterMenu = this.renderFilterMenu()
    const filterItem = this.renderFilterItem()

    return (
      <div>
        <Flex align='center' justify='space-between'>
          <h4 styleName='filterTitle'>Filters:</h4>
          <Flex>
            {filterMenu}
            <IconButton
              theme={styles}
              icon='cached'
              styleName='filterRefreshBtn'
              onClick={this.onRefreshFilter()}
            />
          </Flex>
        </Flex>
        <div styleName='listFilterWrapper'>
          {filterItem}
        </div>
      </div>
    )
  }
}

ListFilter.PropTypes = {
  sources: PropTypes.object.isRequired,
  filterHandlers: PropTypes.object.isRequired,
  filterStatus: PropTypes.object.isRequired,
  filterPairs: PropTypes.object.isRequired,

  onRefreshFilter: PropTypes.func.isRequired,
  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
}

export default CSSModules(ListFilter, styles)

